<template>
  <div id="app">
    <a-config-provider :locale="locale">
      <router-view/>
    </a-config-provider>
  </div>
</template>
<script>
import { getUrlKey } from '@/utils/util'
export default {
  computed: {
    locale () {
      console.log('this.$store.getters.lang', this.$store.getters.lang)
      return this.$i18n.getLocaleMessage(this.$store.getters.lang).antLocale
    }
  },
  created: function () {
    const lang = getUrlKey('lang')
    if (lang === 'zh-CN') {
      this.$store.dispatch('setLang', 'zh-CN')
    } else {
      this.$store.dispatch('setLang', 'en-US')
    }
  }
}

</script>
<style lang="less">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
